export default __webpack_public_path__ + "locales/pt-BR/Files.json?hash=ec4b736c927deb1a0126bf08e79729c9";